import type { ShipmentSearchFilters } from '@/views/screens/Shipment/types';
import i18n from 'i18next';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT, SORTING_ORDERS } from './common';

export const SHIPMENT_EXPORT_SHIPMENT_INFORMATION_FIELDS = () => [
  {
    name: 'shipmentNo',
    label: i18n.t('translation:default.fields.shipmentNumber.label'),
  },
  {
    name: 'status',
    label: i18n.t('translation:default.fields.shipmentStatus'),
  },
  {
    name: 'shipmentTermsDesc',
    label: i18n.t('translation:default.fields.shipmentTerms.label'),
  },
  {
    name: 'expShipDate',
    label: i18n.t('translation:default.fields.expectedShipDate.label'),
  },
  {
    name: 'expDeliveryDate',
    label: i18n.t('translation:default.fields.expectedDeliveryDate'),
  },
  { name: 'multiStop', label: i18n.t('translation:default.fields.multiStop') },
  {
    name: 'shipperName',
    label: i18n.t('translation:default.fields.shipperName.label'),
  },
  {
    name: 'shipperCountryCode',
    label: i18n.t('translation:default.fields.shipperCountry.label'),
  },
  {
    name: 'shipperZip',
    label: i18n.t('translation:default.fields.shipperPostalCode'),
  },
  {
    name: 'shipperState',
    label: i18n.t('translation:default.fields.shipperState'),
  },
  {
    name: 'shipperCity',
    label: i18n.t('translation:default.fields.shipperCity.label'),
  },
  {
    name: 'shipperPortType',
    label: i18n.t('translation:default.fields.shipperPortType'),
  },
  {
    name: 'consigneeName',
    label: i18n.t('translation:default.fields.consigneeName.label'),
  },
  {
    name: 'countryCode',
    label: i18n.t('translation:default.fields.consigneeCountry.label'),
  },
  {
    name: 'consigneeZip',
    label: i18n.t('translation:default.fields.consigneePostalCode.label'),
  },
  {
    name: 'consigneeState',
    label: i18n.t('translation:default.fields.consigneeState.label'),
  },
  {
    name: 'consigneeCity',
    label: i18n.t('translation:default.fields.consigneeCity.label'),
  },
  {
    name: 'consigneePortType',
    label: i18n.t('translation:default.fields.consigneePortType'),
  },
  {
    name: 'totalWeight',
    label: i18n.t('translation:default.fields.chargebleWeight'),
  },
  { name: 'weightUom', label: i18n.t('translation:default.fields.weightUOM') },
  { name: 'totalUnits', label: i18n.t('translation:default.fields.billQty') },
  {
    name: 'uom',
    label: i18n.t('translation:default.fields.packageBilledQuantityunitOfMeasure'),
  },
  {
    name: 'palletLoadType',
    label: i18n.t('translation:default.fields.palletLoadType.label'),
  },
  { name: 'totalCube', label: i18n.t('translation:default.fields.cube.label') },
  {
    name: 'shipmentCargoType',
    label: i18n.t('translation:default.fields.shipmentCargoType'),
  },
  {
    name: 'shipmentTransportationProvider',
    label: i18n.t('translation:default.fields.shipmentTransportationProvider'),
  }, //->?
  {
    name: 'incoTerms',
    label: i18n.t('translation:default.fields.incoTerm.label'),
  },
  {
    name: 'rateShopCost',
    label: i18n.t('translation:default.fields.shipmentCost'),
  },
  {
    name: 'totalMileage',
    label: i18n.t('translation:shipment.drawer.details.distanceMiles'),
  },
  {
    name: 'totalKm',
    label: i18n.t('translation:shipment.drawer.details.distanceKm'),
  },
  { name: 'shipmentNotes', label: i18n.t('translation:default.fields.notes') },
  {
    name: 'detailNotes',
    label: i18n.t('translation:default.fields.internalNotes.label'),
  },
  {
    name: 'bolPrinted',
    label: i18n.t('translation:default.fields.printedBillOfLading'),
  },
  {
    name: 'createdOn',
    label: i18n.t('translation:default.fields.createdOn.title'),
  },
  {
    name: 'fullName',
    label: i18n.t('translation:default.fields.createdByFullName'),
  },
  {
    name: 'userEmail',
    label: i18n.t('translation:default.fields.createByEmailAddress'),
  },
  {
    name: 'modifiedOn',
    label: i18n.t('translation:default.fields.modifiedOn'),
  },
  {
    name: 'modifiedFullName',
    label: i18n.t('translation:default.fields.modifiedBy'),
  },
];

export const SHIPMENT_EXPORT_SHIPMENT_ADDITIONAL_INFORMATION_FIELDS = () => [
  {
    name: 'masterBolNumber',
    label: i18n.t('translation:default.fields.masterBOLNo'),
  },
  { name: 'bolNumber', label: i18n.t('translation:default.fields.houseBOLNo') },
  {
    name: 'containerNumber',
    label: i18n.t('translation:default.fields.containerNumber.label'),
  },
  {
    name: 'masterShipmentNo',
    label: i18n.t('translation:default.fields.masterShipmentNo'),
  },
  {
    name: 'isTpaSelected', // -> *
    label: i18n.t('translation:default.fields.transportationProviderAppointmentNumber'),
  }, //->?
  {
    name: 'proNo',
    label: i18n.t('translation:default.fields.freightBillNumber'),
  }, //->?
  {
    name: 'isDisplayStopShow',
    label: i18n.t('translation:default.fields.displayStopOffs'),
  }, //->? // -> *
  {
    name: 'poNumber',
    label: i18n.t('translation:default.fields.purchaseOrderNumber'),
  },
  {
    name: 'soNumber',
    label: i18n.t('translation:default.fields.salesOrderNumber'),
  },
  {
    name: 'partNumber',
    label: i18n.t('translation:default.fields.partNumber'),
  },
  {
    name: 'partDescription',
    label: i18n.t('translation:default.fields.partNumberDescription'),
  },
  {
    name: 'transportationPO',
    label: i18n.t('translation:shipmentAdd.shipmentDetails.transportationPO.label'),
  },
  {
    name: 'FreightClass',
    label: i18n.t('translation:default.fields.freightClass.label'),
  },
  {
    name: 'ConsigneeTrailerNumber',
    label: 'Consignee Trailer Number',
  },
];

export const SHIPMENT_EXPORT_SHIPMENT_RATE_DETAILS_FIELDS = () => [
  {
    name: 'pricingBasis',
    label: i18n.t('translation:default.fields.pricingBasis.label'),
  }, // -> *
  {
    name: 'rateSubmittedOn',
    label: i18n.t('translation:default.fields.rateSubmittedOn'),
  }, // -> *
  {
    name: 'carrierName',
    label: i18n.t('translation:default.fields.transportationProvider.label'),
  }, // -> *
  { name: 'cost', label: i18n.t('translation:default.fields.cost') }, // -> *
  {
    name: 'convertedCurrency',
    label: i18n.t('translation:default.fields.costCurrency'),
  }, // -> *
  {
    name: 'shipmentCancelCost',
    label: i18n.t('translation:default.fields.shipmentCancelCost'),
  }, // -> *
  {
    name: 'shipmentCancelCostCurrency',
    label: i18n.t('translation:default.fields.shipmentCancelCostCurrency'),
  }, // -> *
  {
    name: 'showSpotBidCarrier',
    label: i18n.t('translation:default.fields.showAllSpotBidCarrier'),
  }, //->? // -> *
  {
    name: 'cargoType',
    label: i18n.t('translation:default.fields.cargoType.label'),
  }, // -> *
  {
    name: 'serviceType',
    label: i18n.t('translation:default.fields.serviceLevel.label'),
  }, // -> *
  {
    name: 'stdTransitDay',
    label: i18n.t('translation:default.fields.transitDays'),
  }, // -> *
  {
    name: 'rateStatus',
    label: i18n.t('translation:default.fields.rateStatus'),
  }, // -> *
];

export const SHIPMENT_EXPORT_ASYNC_FIELDS = [
  'isTpaSelected',
  'isDisplayStopShow',
  'pricingBasis',
  'rateSubmittedOn',
  'carrierName',
  'cost',
  'convertedCurrency',
  'showSpotBidCarrier',
  'cargoType',
  'serviceType',
  'rateStatus',
  'FreightClass',
  'masterBolNumber',
  'bolNumber',
  'containerNumber',
  'ConsigneeTrailerNumber',
  'masterShipmentNo',
  'proNo',
  'poNumber',
  'soNumber',
  'partNumber',
  'partDescription',
  'transportationPO',
  'shipmentCancelCost',
];

export const SHIPMENT_RATE_SHOP_RESULTS_EXPORT_COLUMNS = [
  { name: 'RateShopKey' },
  { name: 'Transportation Provider' },
  { name: 'Converted Price' },
  { name: 'Converted Currency Code' },
  { name: 'Pricing Basis' },
  { name: 'Standard Transit Days' },
  { name: 'Cargo Type' },
  { name: 'Service Description' },
  { name: 'Equipment Type' },
  { name: 'Equipment Type Detail' },
  { name: 'User Submitted' }, // ->?
  { name: 'Created On' },
  { name: 'Bid Expiry Date' }, // ->?
  { name: 'Bid Comment' },
  { name: 'Spot Quote Number' },
];

export const SHIPMENT_FOOTER_TYPES = {
  LATE_PICKUP: 'LP',
  MISSING_DOCUMENTS: 'MD',
  PICKUP_FAILED: 'PF',
  TRACKING_FAILURES: 'TF',
  LATE_DELIVERY: 'LD',
};

export const SHIPMENT_RATE_SHOP_RATTING_PREFERENCES = {
  ALL_CARRIERS: 'ALL',
  LEAST_COST: 'LC',
  REQUIRED: 'REQ',
};

export const SHIPMENT_TRACKING_TYPES = {
  FEDEX: 'FEDEX',
  UPS: 'UPS',
  DHL: 'DHL',
};

export const SHIPMENT_PRINTS_TAB_ID = {
  COMMERCIAL_INVOICE: '1',
  PACKING_LIST: '2',
  BOL: '3',
  IMO: '4',
  SED: '5',
  CMR: '6',
};

export const SHIPMENT_PRINTS_DOC_TYPES = {
  [SHIPMENT_PRINTS_TAB_ID.COMMERCIAL_INVOICE]: 'CI',
  [SHIPMENT_PRINTS_TAB_ID.PACKING_LIST]: 'PL',
  [SHIPMENT_PRINTS_TAB_ID.BOL]: 'BOL',
  [SHIPMENT_PRINTS_TAB_ID.CMR]: 'CMR',
  [SHIPMENT_PRINTS_TAB_ID.SED]: 'SED',
};

export const SHIPMENT_PRINTS_ENABLED_STATUS = [
  'Tender',
  'Auto-Tendered',
  'In-Transit',
  'Confirmed',
  'Approved',
  'Closed',
];

export const SHIPMENT_NOTIFICATION_DISTRIBUTORS_SORTING_FIELDS = [
  {
    value: 'distributionName',
    label: i18n.t('translation:default.fields.distributorName'),
  },
  { value: 'status', label: i18n.t('translation:default.fields.status.label') },
  {
    value: 'description',
    label: i18n.t('translation:default.fields.description'),
  },
];

export const SHIPMENT_NOTIFICATION_ROUTING_SORTING_FIELDS = () => [
  {
    value: 'routingTypeName',
    label: i18n.t('translation:default.fields.routingType.label'),
  },
  { value: 'status', label: i18n.t('translation:default.fields.status.label') },
  {
    value: 'carrierName',
    label: i18n.t('translation:default.fields.transportationProvider.label'),
  },
  {
    value: 'userName',
    label: i18n.t('translation:default.fields.userName.label'),
  },
  {
    value: 'cargoName',
    label: i18n.t('translation:default.fields.cargoType.label'),
  },
  {
    value: 'branchName',
    label: i18n.t('translation:default.fields.branch.label'),
  },
  {
    value: 'countryName',
    label: i18n.t('translation:default.fields.country.label'),
  },
  {
    value: 'locationTypeName',
    label: i18n.t('translation:default.fields.locationType.label'),
  },
];

export const GET_QUOTE_FORM_IDS = {
  quoteDetailsForm: '1',
  stopsForm: '2',
  productForm: '3',
  transportationProviderSearchForm: '4',
};

export const SHIPMENT_STOP_TYPES = {
  ORIGIN: 'ORIGIN',
  DEST: 'DEST',
};

export const DEFAULT_RATE_SHOP_ITEMS_VALUE = {
  selected: false,
  numberOfPieces: 0,
  length: 0,
  billedWeight: 0,
  height: 0,
  billQuantity: 0,
  width: 0,
  cube: 0,
};

export const GLOBAL_RATE_SHOP_FORM_DEFAULT_VALUES = {
  branchKey: '-1',
  pricingBasis: '**',
  currencyCode: 'USD',
  pricingType: 'PACT',
  timeFrame: 'C',
  shipmentType: 'O',
  shipmentTerms: 'P',
  measurementUit: 'LB',
  trailerKey: -1,
  declaredValue: 0,
  LDMValue: 0,
  CODValue: 0,
};

export const DEFAULT_SHIPMENT_TABLE_VIEW_COLUMNS = [
  {
    columnName: 'Shipment Status',
    columnValue: 'status',
  },
  {
    columnName: 'Multi Stop',
    columnValue: 'multiStop',
  },
  {
    columnName: 'Transportation provider',
    columnValue: 'carrierName',
  },
  {
    columnName: 'Origin',
    columnValue: 'shipper',
  },
  {
    columnName: 'Destination',
    columnValue: 'consignee',
  },
  {
    columnName: 'Shipment Cost',
    columnValue: 'rateShopCost',
  },
  {
    columnName: 'Currency',
    columnValue: 'convertedCurrency',
  },
  {
    columnName: 'Approval No',
    columnValue: 'approvalNumber',
  },
  {
    columnName: 'Quote No',
    columnValue: 'quoteNo',
  },
];

export const HAZMAT_VALUES = {
  Y: 'Yes',
  y: 'Yes',
  N: 'No',
  n: 'No',
};

export const SHIPMENT_STOP_TYPE_LABEL = {
  1: 'Pickup',
  2: 'Delivery',
};

export const SHIPMENT_FOB_CODE_LABEL = {
  ORIG: 'Origin',
  DEST: 'Destination',
};

export const getShipmentDefaultFilters = (): ShipmentSearchFilters => ({
  CreatedDateFrom: moment(new Date()).subtract(1, 'months'),
  CreatedDateTo: moment(new Date()),
  PageNumber: 1,
  PageSize: 20,
  ShipmentTerms: undefined,
  CargoType: undefined,
  OrderBySort: SORTING_ORDERS.DESC,
  OrderByColumn: 'CreatedOn',
  QuoteNo: undefined,
  ApprovalNumber: undefined,
  ShipmentStatus: undefined,
  ShipmentNo: undefined,
  ExpShipFrom: undefined,
  ExpShipTo: undefined,
  BranchKey: undefined,
  CarrierKey: undefined,
  PoNo: undefined,
  SoNo: undefined,
  BolNumber: undefined,
  ProjectNo: undefined,
  createdBy: undefined,
  VendorKey: undefined,
  OCountryCode: undefined,
  ShipperName: undefined,
  ShipperCity: undefined,
  ShipperState: undefined,
  ShipperZip: undefined,
  CCountryCode: undefined,
  ConsigneeName: undefined,
  ConsigneeCity: undefined,
  ConsigneeState: undefined,
  ConsigneeZip: undefined,
  IncoTerms: undefined,
  shipmentOriginator: undefined,
  modifiedBy: undefined,
});
export const getSearchQuoteDefaultFilters = () => ({
  spotQuoteCreatedFrom: moment(new Date()).subtract(1, 'months').format(DEFAULT_DATE_FORMAT),
  spotQuoteCreateTo: moment(new Date()).format(DEFAULT_DATE_FORMAT),
  quoteNumber: '',
  shipmentNumber: '',
  quotestatus: '',
  expectedShipFromDate: '',
  expectedShipTodate: '',
  transporterKey: null,
  createdBy: '',
  shipperCountry: '',
  shipperCity: '',
  consigneeCountry: '',
  consigneeCity: '',
  transportationMode: '',
  transportationGroup: '',
  urgency: '',
  poNumber: '',
  shipperPort: '',
  consigneePort: '',
  hazardousClass: '',
  agingParam: '',
});

export const SHIPMENT_STATUS_FOR_ADVANCED_PLANNING_NOTICE = ['Rated', 'Planning', 'Auto-Rated'];

export const SHIPMENT_PALLET_PACKAGE_TYPE_UOM = {
  EUP: { length: 120, width: 80, height: 160, dimUom: 'C' },
  CHP: { length: 120, width: 100, height: 160, dimUom: 'C' },
};

export const PARCEL_EXPRESS_CARRIER_TYPES_FOR_SHIPPER_ACCOUNT = {
  DHLC: 'DHLC',
  FEDX: 'FEDX',
  UPSN: 'UPSN',
};

export const INTEGER_NUMBER_ONLY_VALIDATION_REGEX = /^[0-9][0-9]*$/g;
export const SAVERS_PRODUCT_DIVIDE_VALUE = 23;

export const SHIPMENT_STATUSES = {
  DRAFT: 'Draft',
  PRE_BOOKING: 'Pre-Booking',
};

export const PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE = {
  BOTH_EXIST: 'N',
  SHIPPER: 'S',
  CONSIGNEE: 'C',
  BOTH: 'SC',
};

export const PARCEL_EXPRESS_ADDRESS_VALIDATION_MESSAGE = {
  [PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE.SHIPPER]: 'Do you want to add Shipper address to address book?',
  [PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE.CONSIGNEE]: 'Do you want to add Consignee address to address book?',
  [PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE.BOTH]: 'Do you want to add Shipper and Consignee address to address book?',
};
